export const validateInput = (inputValue, requiresFreeText) => {
  const inputLength = inputValue.length
  let errorText = null

  if (typeof inputValue !== 'string') {
    errorText = 'Beskrivningen är av otillåtet format.'
  } else if (inputLength > 1000) {
    errorText = 'Beskrivningen får max vara 1000 tecken.'
  } else if (requiresFreeText && !inputLength > 0) {
    errorText = 'Du måste lämna en beskrivning'
  }

  const errorObj = { hasError: false, errorText }
  if (errorText) {
    errorObj.hasError = true
  }
  return errorObj
}
